import React, { useState, useEffect } from 'react';
import { NavLink, useParams} from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { Tooltip } from 'react-tooltip';
import apiService from './../../../Auth/apiService.jsx';
import DatosCabezaFamilia from '../../Caracterizacion/DatosCabezaFamilia.jsx';
import { useAuth } from './../../../Auth/AuthContext.jsx';
import SweetAlert2 from 'react-sweetalert2';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale, setDefaultLocale, DatePicker } from 'react-datepicker';
import { es } from 'date-fns/locale';
import MenuReincorporados from './../MenuReincorporados.jsx';
import { Accordion, Card, useAccordionButton } from 'react-bootstrap';
import CustomInput from '../../Utils/CustomInput2.jsx';
registerLocale('es', es);
setDefaultLocale('es');

function BotonAbrirListadoAtenciones({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    console.log('totally custom!'),
  );

  return (
    <button
        className="btn btn-primary"
        type="button"
        onClick={decoratedOnClick}
    >
      {children}
    </button>
  );
}

export default function Prevencionrei(){
    const { token, rol, user, sedeActual } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [expandedPrevenciones, setExpandedPrevenciones] = useState({});
    const { idCabezaFamilia } = useParams();
    const [swalProps, setSwalProps] = useState({});
    const [ayudas, setAyudas] = useState([]);
    const [entidades, setEntidades] = useState([]);
    const [integrantes, setIntegrantes] = useState([]);
    const [tiposAsesoria, setTiposAsesoria] = useState([]);
    const [listadoAtenciones, setListadoAtenciones] = useState([]);
    const [seguimientosAtenciones, setSeguimientosAtenciones] = useState([]);
    const { control, handleSubmit, register, setValue, watch, reset, formState: { errors }} = useForm();
    const idPrevencion = watch('idPrevencion');
    const [cabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
    });
    async function ConsultarListadoAtenciones(idCabezaFamilia, usrRolid, usrId) {
        let url = '/reincorporados/listarprevenciones';
        let obj = {idCabezaFamilia: idCabezaFamilia, usrRolid: usrRolid, usrId: usrId }
        try {
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            setListadoAtenciones(result.atenciones || []);
            setSeguimientosAtenciones(result.seguimientos || []);
        } catch (error) {
            console.error('Error fetching listado atenciones:', error);
        }
        
    }
    useEffect(() => {
    
        const fetchData = async () => {
            let url = '/reincorporados/crearformularioregistroprevencion';
            let obj = {idCabezaFamilia: idCabezaFamilia, usrRolid: rol, usrId: user }
            try {
                setCargando(true);
                const response = await apiService.post(url, obj, token);
                const result = await response.data;
                setCabezaFamiliaDatos(result.cabezafamilia);
                setEntidades(result.entidades);
                setAyudas(result.ayudas);
                setIntegrantes(result.integrantesdto);
                setTiposAsesoria(result.tiposasesoria);
                ResetForm();
                setValue('usrId', user);
                setValue('cabIdcabezafamilia', idCabezaFamilia);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
        };
        ConsultarListadoAtenciones(idCabezaFamilia, rol, user);
        fetchData();
    }, [idCabezaFamilia, rol, user]);
    const onSubmit = async (data) => {
        const nombreayuda = ayudas.find((item) => item.id === data.idayuda).ayuAyuda;
        const nombreentidad = entidades.find((item) => item.id.toString() === data.identidad).entEntidad;
        data.ayuda = nombreayuda
        data.entidad = nombreentidad
        data.sedeActual = sedeActual;
        data.usrId = user;
        data.cabIdcabezafamilia = idCabezaFamilia;
        setCargando(true);
        let url;
        url = '/reincorporados/registrarprevencion';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Registrar prevencion', JSON.stringify(response.data));
                ResetForm();
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Registrar prevencion', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Registrar prevencion', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    
    const ResetForm = () => {
        reset();
        const fechahoy = new Date()
        setValue('idPrevencion', '');
        setValue('fecha', fechahoy);
    }
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    async function handleNuevoSeguimiento(prevencionId) {
        const detalleAtencion = listadoAtenciones.find(item => item.prevencion_id === prevencionId);
        ResetForm();
        setValue('idPrevencion', detalleAtencion?.prevencion_id || '');
        setValue('idpersona', detalleAtencion?.per_idpersona || '');
    }

    const obtenerIdSeguimiento = (seguimiento) => (
        seguimiento?.int_idprevencion ??
        seguimiento?.prevencion_id ??
        seguimiento?.idPrevencion ??
        seguimiento?.idprevencion ??
        seguimiento?.id_prevencion ??
        ''
    );

    const togglePrevencion = (prevencionId) => {
        setExpandedPrevenciones((prevState) => ({
            ...prevState,
            [prevencionId]: !prevState[prevencionId],
        }));
    };

    const renderSeguimientos = (prevencionId) => {
        const seguimientosFiltrados = seguimientosAtenciones.filter(
            (seguimiento) => String(obtenerIdSeguimiento(seguimiento)) === String(prevencionId)
        );

        if (seguimientosFiltrados.length === 0) {
            return (
                <tr>
                    <td colSpan={9} className="bg-light text-muted">
                        No hay seguimientos registrados para esta prevenci&oacute;n.
                    </td>
                </tr>
            );
        }

        return seguimientosFiltrados.map((seguimiento, index) => (
            <tr key={`${prevencionId}-seguimiento-${seguimiento.id ?? index}`} className="table-secondary">
                <td></td>
                <td colSpan={2}>
                    <strong>Seguimiento</strong>
                </td>
                <td>{seguimiento.int_iddetalleatencion ?? '-'}</td>
                <td>{seguimiento.det_fecha ?? '-'}</td>
                <td>{seguimiento.det_observaciones ?? '-'}</td>
            </tr>
        ));
    };
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Garant&iacute;a de derechos - prevenci&oacute;n</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} >Grupo familiar</NavLink></li>}
                        <li className="breadcrumb-item active"> Garant&iacute;a de derechos - prevenci&oacute;n</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuReincorporados idCabezaFamilia={idCabezaFamilia} />
                    <div className="row">
                    <div className="col-md-12">
                        <div className="card card-info">
                            <Accordion defaultActiveKey="0">
                                <Card>
                                    <Card.Header>
                                    <BotonAbrirListadoAtenciones eventKey="0">Listado atenciones prevenci&oacute;n</BotonAbrirListadoAtenciones>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="0">
                                    <Card.Body>
                                        <div style={{maxHeight:"300px", overflowY:"auto"}}>
                                            <table className="table" style={{width:"100%", borderCollapse:"collapse"}}>
                                                <thead>
                                                    <tr>
                                                        <th>Acciones</th>
                                                        <th>ID Prevenci&oacute;n</th>
                                                        <th>Documento</th>
                                                        <th>Nombre</th>
                                                        <th>ID Cabeza Familia</th>
                                                        <th>Parentesco</th>
                                                        <th>Fecha</th>
                                                        <th>Hora</th>
                                                        <th>Observaciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {listadoAtenciones.map((atencion) => (
                                                        <React.Fragment key={atencion.id}>
                                                            <tr>
                                                                <td>
                                                                    <button 
                                                                        type="button" 
                                                                        className="btn btn-primary btn-sm me-2"
                                                                        onClick={() => handleNuevoSeguimiento(atencion.prevencion_id)}
                                                                    >Nuevo seguimiento</button>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-secondary btn-sm"
                                                                        onClick={() => togglePrevencion(atencion.prevencion_id)}
                                                                    >
                                                                        {expandedPrevenciones[atencion.prevencion_id] ? 'Ocultar' : 'Ver'} seguimientos
                                                                    </button>
                                                                </td>
                                                                <td>{atencion.prevencion_id}</td>
                                                                <td>{atencion.per_idpersona}</td>
                                                                <td>{atencion.nombre}</td>
                                                                <td>{atencion.gru_idcabezafamilia}</td>
                                                                <td>{atencion.par_parentesco}</td>
                                                                <td>{atencion.det_fecha}</td>
                                                                <td>{atencion.det_horaatencion}</td>
                                                                <td>{atencion.det_observaciones}</td>
                                                            </tr>
                                                            {expandedPrevenciones[atencion.prevencion_id] && (
                                                                <tr>
                                                                    <td colSpan={9} className="p-0">
                                                                        <div className="p-3 bg-white border-top">
                                                                            <div className="table-responsive">
                                                                                <table className="table table-sm table-bordered mb-0">
                                                                                    <thead className="table-light">
                                                                                        <tr>
                                                                                            <th></th>
                                                                                            <th colSpan={2}>Seguimiento</th>
                                                                                            <th>Id Detalle atenci&oacute;n</th>
                                                                                            <th>Fecha</th>
                                                                                            <th>Observaciones</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {renderSeguimientos(atencion.prevencion_id)}
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        
                                    </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                <DatosCabezaFamilia datos={cabezaFamiliaDatos}></DatosCabezaFamilia>
                                <input hidden {...register('usrId')}/>
                                <input hidden {...register('cabIdcabezafamilia')}/>
                                <input hidden {...register('sedeActual')}/>
                                {idPrevencion != '' && <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="idPrevencion">Id prevenci&oacute;n para seguimiento</label>
                                            <input
                                                readOnly
                                                className="form-control"
                                                id="idPrevencion"
                                                {...register('idPrevencion')}
                                                placeholder="Id"
                                            />
                                        </div>
                                    </div>
                                </div>}
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label htmlFor="identidad">Entidad:</label>
                                            <select id="identidad" {...register('identidad', { required: true })} className='form-control' >
                                                {entidades.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                {option.id} {option.entEntidad}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.identidad && <p style={{color: 'red'}}>Seleccione identidad</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label htmlFor="idayuda">Ayuda:</label>
                                            <select {...register('idayuda', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {ayudas.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.ayuAyuda}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.idayuda && <p style={{color: 'red'}}>Seleccione atencion</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label htmlFor="idpersona">Integrante:</label>
                                            <select id="idpersona" {...register('idpersona', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {integrantes.map((option) => (
                                                <option key={option.per_idpersona} value={option.per_idpersona}>
                                                    {option.par_parentesco} {option.per_idpersona} {option.nombre}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.idpersona && <p style={{color: 'red'}}>Seleccione integrante</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="fecha">Fecha atenci&oacute;n</label>
                                            <Controller
                                                control={control}
                                                name="fecha"
                                                render={({ field }) => (
                                                    <DatePicker
                                                    placeholderText="Fecha"
                                                    onChange={(date) => field.onChange(date)}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    selected={field.value}
                                                    customInput={<CustomInput />}
                                                    locale="es"
                                                    dateFormat="yyyy-MM-dd"
                                                    maxDate={new Date()}
                                                    />
                                                )}
                                            />
                                            {errors.fecha && <p style={{color: 'red'}}>Digite fecha de atencion</p>}
                                        </div>
                                    </div>
                                </div>
                                {idPrevencion == '' && <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="intIdtipoasesoria">Tipo de Asesoria</label>
                                            <select
                                                className="form-control"
                                                id="intIdtipoasesoria"
                                                {...register('intIdtipoasesoria', { required: true })}
                                            >
                                                <option value="">Seleccione un tipo de asesoria</option>
                                                {tiposAsesoria.map((tipo) => (
                                                    <option key={tipo.id} value={tipo.id}>
                                                        {tipo.strNombre}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="bolDerivacionexterna">El servicio prestado requiere derivaci&oacute;n interna o externa</label>
                                            <select
                                                type="checkbox"
                                                className="form-control"
                                                id="bolDerivacionexterna"
                                                {...register('bolDerivacionexterna')}
                                            >
                                                <option value="">Seleccione</option>
                                                <option value="true">SI</option>
                                                <option value="false">NO</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="strEntidadderivacion">Entidad a la que se realiza la derivaci&oacute;n</label>
                                            <input
                                                className="form-control"
                                                id="strEntidadderivacion"
                                                {...register('strEntidadderivacion')}
                                                placeholder="Entidad de derivación"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="strEntidadremitido">Entidad a la que fue remitido</label>
                                            <input
                                                className="form-control"
                                                id="strEntidadremitido"
                                                {...register('strEntidadremitido')}
                                                placeholder="Entidad remitido"
                                            />
                                        </div>
                                    </div>
                                </div>}
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="observaciones">Observaciones</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('observaciones', { required: true })}
                                                placeholder="observaciones"
                                            />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                <div className="card-footer">
                                    <button type="submit" className="btn btn-primary">Guardar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                    </div>
                </div>
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}